// PHOTO PIXEL® — product-first brand data
export const BRAND = {
  name: "PHOTO PIXEL®",
  slogan: "Memories Worth Framing.",
  logo: "/brand/photopixel-logo.webp",
  founder: {
    name: "VISHAL DHUMALE",
    role: "FOUNDER & OWNER",
    quote:
      "At PHOTO PIXEL®, we believe every memory deserves a beautiful place in your home.",
    photo: "/brand/vishal-dhumale.webp",
  },
  social: {
    productInsta: "https://www.instagram.com/photopixel.co.in",
    storiesInsta: "https://www.instagram.com/photopixel_stories",
    productHandle: "@photopixel.co.in",
    storiesHandle: "@photopixel_stories",
  },
};

export const LOCATIONS = [
  {
    id: "baner",
    name: "BANER",
    label: "Head Office & Main Store",
    tagline: "Prints • Frames • Photo Gifts",
    address: [
      "Shop No. 1, Yash Tower, Chowk,",
      "Pancard Club Road, Near Shroff House,",
      "Baner Gaon, Baner, Pune,",
      "Maharashtra – 411069",
    ],
    phone: "+91 99759 92227",
    tel: "+919975992227",
    email: "Order@photopixel.co.in",
    instagram: "https://www.instagram.com/photopixel.co.in",
    instaHandle: "@photopixel.co.in",
    instaNote: "Prints • Frames • Photo Gifts",
    maps: "https://maps.app.goo.gl/8D8QmeCwSSKFmZFr6?g_st=i",
  },
  {
    id: "vishal-nagar",
    name: "VISHAL NAGAR",
    label: "Branch",
    tagline: "Prints • Frames • Photo Gifts • Wall Art • Albums",
    address: [
      "Shop No. 2, Parkwood Society, New DP Road,",
      "Beside Trends, Brahmavrind Housing Society,",
      "Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad,",
      "Maharashtra – 411027",
    ],
    phone: "+91 99759 92227",
    tel: "+919975992227",
    email: "Vishalnagar@photopixel.co.in",
    instagram: "https://www.instagram.com/photopixel_stories",
    instaHandle: "@photopixel_stories",
    instaNote: "Our Photographic Services",
    maps: "https://maps.app.goo.gl/WppLjaFTEZhgXsLQ7?g_st=iw",
  },
  {
    id: "wakad",
    name: "WAKAD",
    label: "Coming Soon",
    comingSoon: true,
  },
];

export const waLink = (text) =>
  `https://wa.me/919975992227?text=${encodeURIComponent(
    text || "Hi PHOTO PIXEL, I'd like to print and frame my memories."
  )}`;

export const NAV = [
  { label: "Home", id: "home" },
  { label: "Frames", id: "frames" },
  { label: "Prints", id: "prints" },
  { label: "Photo Gifts", id: "gifts" },
  { label: "Wall Art", id: "wallart" },
  { label: "Albums", id: "albums" },
];

export const NAV_MORE = [
  { label: "Photography", id: "photography" },
  { label: "Videography", id: "videography" },
  { label: "Photo Restoration", id: "restoration" },
];

const U = (id, q = 85) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=${q}&w=1400`;

export const IMG = {
  heroInterior: U("1615876234886-fd9a39fda97f"),
  interiorWhite: U("1550243595-4cb7dd708a89"),
  galleryAssorted: U("1513519245088-0e12902e5a38"),
  woodFrame: "https://static.prod-images.emergentagent.com/jobs/02c394d3-6fe3-4fef-a66d-f11940508881/images/baccecb5d6529c87e8d95cd77f906e97b25b25f88f9b7b3775f846203ab6075c.jpeg",
  personalizedFrame: "https://static.prod-images.emergentagent.com/jobs/02c394d3-6fe3-4fef-a66d-f11940508881/images/28e40f571e819c131f620b20557663efc87bd0289a9f5f04d78f6bf2b80df598.jpeg",
  customFrame: "https://static.prod-images.emergentagent.com/jobs/02c394d3-6fe3-4fef-a66d-f11940508881/images/f933790d0063132753b203dc40e29d3d92f546dd0ff19d2206d03f9d099fc638.jpeg",
  blackFrame: U("1683523946422-64283e8af4d5"),
  blackTrio: U("1773867567786-99e27b041610"),
  canvas: U("1594408052115-7e8b8a6261f9"),
  canvas2: U("1647082550285-119acfd169f2"),
  mug: U("1576962101359-dc312a5ee63b"),
  mugPlant: U("1509046725455-ad9638a050e8"),
  albumOpen: U("1676883344224-2fa5de6025db"),
  albumBook: U("1646645733353-55c8bfb60a70"),
  albumFlat: U("1662108052701-29c0d7fd0456"),
  oldPhoto: U("1542216515-4e6a586c1ca0"),
  oldPhoto2: U("1593968007877-b351c54bef61"),
  printsStack: "https://images.pexels.com/photos/9219057/pexels-photo-9219057.jpeg?auto=compress&cs=tinysrgb&w=1400",
  printsHold: "https://images.pexels.com/photos/9219062/pexels-photo-9219062.jpeg?auto=compress&cs=tinysrgb&w=1400",
  giftBox: "https://images.pexels.com/photos/7764418/pexels-photo-7764418.jpeg?auto=compress&cs=tinysrgb&w=1400",
  // photography (secondary)
  photoWedding: U("1519741196428-6a2175fa2557"),
  photoVideography: U("1496559249665-c7e2874707ea"),
  photoProduct: "https://images.pexels.com/photos/23991039/pexels-photo-23991039.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const CATEGORIES = [
  { no: "01", title: "Photo Frames", desc: "Premium frames in wood, black, white, metallic and glass.", image: IMG.woodFrame, id: "frames" },
  { no: "02", title: "Photo Prints", desc: "From everyday snapshots to large statement enlargements.", image: IMG.printsStack, id: "prints" },
  { no: "03", title: "Photo Gifts", desc: "Turn your favourite moments into personalized keepsakes.", image: IMG.mug, id: "gifts" },
];

export const FRAMES = [
  { no: "01", name: "Wooden Frames", desc: "Warm, natural and timeless.", image: IMG.woodFrame },
  { no: "02", name: "Black Frames", desc: "Modern, minimal and premium.", image: IMG.blackFrame },
  { no: "03", name: "White Frames", desc: "Clean, bright and contemporary.", image: IMG.interiorWhite },
  { no: "04", name: "Metallic Frames", desc: "Elegant metallic finish.", image: IMG.blackTrio },
  { no: "05", name: "Collage Frames", desc: "Multiple memories, beautifully arranged.", image: IMG.galleryAssorted },
  { no: "06", name: "Floating Frames", desc: "Modern depth effect.", image: IMG.heroInterior },
  { no: "07", name: "Glass Frames", desc: "Clean and sophisticated.", image: IMG.interiorWhite },
  { no: "08", name: "Gallery Wall Sets", desc: "Multiple coordinated frames.", image: IMG.galleryAssorted },
  { no: "09", name: "Tabletop Frames", desc: "For desks, shelves and bedsides.", image: IMG.blackFrame },
  { no: "10", name: "Custom Frames", desc: "Customized sizes and designs.", image: IMG.customFrame },
];

export const FRAME_TABS = [
  { key: "Wood", image: IMG.woodFrame, note: "Warm oak & walnut tones for timeless portraits." },
  { key: "Black", image: IMG.blackFrame, note: "Minimal matte black for a modern gallery look." },
  { key: "White", image: IMG.interiorWhite, note: "Bright, clean edges that suit any interior." },
  { key: "Metallic", image: IMG.blackTrio, note: "Refined metallic finish with subtle sheen." },
  { key: "Glass", image: IMG.interiorWhite, note: "Sleek glass-front for a sophisticated display." },
  { key: "Collage", image: IMG.galleryAssorted, note: "Many memories arranged into one statement piece." },
];

export const PRINTS = [
  { name: "Standard Prints", desc: "4×6, 5×7, 6×8", image: IMG.printsStack },
  { name: "Large Prints", desc: "8×10, 12×18 & enlargements", image: IMG.printsHold },
  { name: "Canvas Prints", desc: "Photographs on premium canvas", image: IMG.canvas },
  { name: "Collage Prints", desc: "Multiple photos arranged together", image: IMG.galleryAssorted },
  { name: "Glossy Finish", desc: "Vivid, premium glossy prints", image: IMG.printsHold },
  { name: "Matte Finish", desc: "Elegant, glare-free matte prints", image: IMG.printsStack },
];

export const GIFTS = [
  { name: "Personalized Frames", desc: "A memory made to be displayed.", image: IMG.personalizedFrame },
  { name: "Photo Mugs", desc: "Your favourite memory, part of every morning.", image: IMG.mug },
  { name: "Photo Cushions", desc: "A favourite photograph you can keep close.", image: IMG.mugPlant },
  { name: "Photo Gift Boxes", desc: "Beautifully packaged memory gifting.", image: IMG.giftBox },
  { name: "Personalized Albums", desc: "Your story, bound beautifully.", image: IMG.albumOpen },
  { name: "Custom Photo Gifts", desc: "Clocks, keychains & more, made yours.", image: IMG.mugPlant },
];

export const ALBUMS = [
  { name: "Wedding Albums", image: IMG.albumOpen },
  { name: "Family Albums", image: IMG.albumBook },
  { name: "Premium Photo Books", image: IMG.albumFlat },
];

export const WHY = [
  { no: "01", title: "Premium Frame Quality" },
  { no: "02", title: "High-Quality Photo Printing" },
  { no: "03", title: "Wide Frame Collection" },
  { no: "04", title: "Customized Designs" },
  { no: "05", title: "Personalized Photo Gifts" },
  { no: "06", title: "Professional Finishing" },
];

export const PROCESS = [
  { no: "01", title: "Choose Your Photo" },
  { no: "02", title: "Select Your Frame" },
  { no: "03", title: "Choose Your Size" },
  { no: "04", title: "We Print & Finish" },
  { no: "05", title: "Ready to Display" },
];

export const WORK_CATEGORIES = ["Frames", "Prints", "Photo Gifts", "Wall Art", "Albums", "Restoration", "Photography"];

export const WORK_ITEMS = [
  { cat: "Frames", image: IMG.woodFrame, title: "Wooden Portrait Frame" },
  { cat: "Frames", image: IMG.blackFrame, title: "Modern Black Frame" },
  { cat: "Frames", image: IMG.galleryAssorted, title: "Collage Wall Set" },
  { cat: "Prints", image: IMG.printsStack, title: "Everyday Prints" },
  { cat: "Prints", image: IMG.printsHold, title: "Enlargements" },
  { cat: "Photo Gifts", image: IMG.mug, title: "Personalized Mug" },
  { cat: "Photo Gifts", image: IMG.giftBox, title: "Memory Gift Box" },
  { cat: "Wall Art", image: IMG.canvas, title: "Canvas Wall Art" },
  { cat: "Wall Art", image: IMG.canvas2, title: "Statement Piece" },
  { cat: "Albums", image: IMG.albumOpen, title: "Wedding Album" },
  { cat: "Albums", image: IMG.albumBook, title: "Family Photo Book" },
  { cat: "Restoration", image: IMG.oldPhoto, title: "Restored Heritage Photo" },
  { cat: "Photography", image: IMG.photoWedding, title: "Wedding Coverage" },
];

export const PHOTOGRAPHY_SERVICES = [
  "Wedding Photography",
  "Pre-Wedding Photography",
  "Event Photography",
  "Portrait Photography",
  "Product Photography",
  "Corporate Photography",
];

export const VIDEOGRAPHY_SERVICES = [
  "Event Videography",
  "Wedding Films",
  "Corporate Videos",
  "Product Videos",
];

export const CONTACT_SERVICES = [
  "Photo Frames",
  "Photo Printing",
  "Photo Gifts",
  "Wall Art",
  "Photo Albums",
  "Photo Restoration",
  "Photography",
  "Videography",
  "Other",
];
